export const common = {
  // Navigation
  'nav.features': 'Özellikler',
  'nav.howItWorks': 'Nasıl çalışır',
  'nav.pricing': 'Fiyatlandırma',
  'nav.faq': 'SSS',
  'nav.aboutUs': 'Hakkımızda',
  'nav.getStarted': 'Başlayın',

  // About Us Section
  'aboutUs.badge': 'Hakkımızda',
  'aboutUs.title': 'Hakkımızda',
  'aboutUs.line1': 'Fikirler ucuzdur.',
  'aboutUs.line2': 'Sermaye değil. Zaman hiç değil.',
  'aboutUs.paragraph1': 'IdeaOracle.ai, çoğu iş fikrinin cesaret eksikliğinden değil – dürüstlük eksikliğinden başarısız olması nedeniyle kuruldu. Çok fazla onay. Çok az gerçeklik.',
  'aboutUs.belief1a': 'Abartıya inanmıyoruz.',
  'aboutUs.belief1b': 'Pazar mantığına inanıyoruz.',
  'aboutUs.belief2a': 'Motivasyona inanmıyoruz.',
  'aboutUs.belief2b': 'Talebe, rekabete ve farklılaşmaya inanıyoruz.',
  'aboutUs.mission1': 'Görevimiz fikirleri iyi göstermek değil.',
  'aboutUs.mission2': 'Görevimiz uygulanabilirliklerini ortaya koymak.',
  'aboutUs.analysis': 'IdeaOracle.ai, iş nişlerini yapısal pazar mekaniği, gerçekçi talep, rekabet yoğunluğu ve uygulanabilirlik açısından analiz eder. Duygusal değil. İyimser değil. Ayık.',
  'aboutUs.failure1': 'Çoğu fikir başarısız olur.',
  'aboutUs.failure2': 'Kurucular yetersiz olduğu için değil –',
  'aboutUs.failure3': 'önceden kimse yeterince net olmadığı için.',
  'aboutUs.clarity': 'Bu netliği sağlamak için varız.',
  'aboutUs.value1': 'Rahatsız edici.',
  'aboutUs.value2': 'Doğrudan.',
  'aboutUs.value3': 'Tutarlı.',
  'aboutUs.confirm': 'Bir fikrin özü varsa, onaylarız.',
  'aboutUs.deny': 'Yoksa, bunu da söyleriz.',
  'aboutUs.noApplause': 'Alkış olmadan.',
  'aboutUs.noSugarcoating': 'Süsleme olmadan.',
  'aboutUs.noTheater': 'Tiyatro olmadan.',

  // Hero Section
  'hero.badge': 'İş nişleri için karar yapay zekası',
  'hero.title1': 'Fikirler ucuzdur.',
  'hero.title2': 'Kötü kararlar değil.',
  'hero.subtitle': 'Yatırım yapmadan önce',
  'hero.subtitleLine2': 'iş nişinizi değerlendiren bir yapay zeka.',
  'hero.cta': 'Fikri kontrol et',
  'hero.ctaSecondary': 'Nasıl çalışır',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'İstek başına kredi',
  'hero.stat2Value': '7+',
  'hero.stat2Label': 'Derecelendirme seviyeleri',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Dürüst ve özel',

  // Features Section
  'features.title1': 'Güçlü özellikler',
  'features.title2': 'modern',
  'features.title3': 'işletmeler için',
  'features.honestVerdict.title': 'Hype skoru değil, dürüst karar',
  'features.honestVerdict.description': 'Gerçek pazar verilerine ve rakip araştırmasına dayalı net iyi/orta/zayıf kararları. Her fikri okşamak için tasarlanmış 9/10 puanlar yok.',
  'features.fullJourney.title': 'Fikir testinden Builder Report’a',
  'features.fullJourney.description': 'Sohbette doğrula, pazar analizine derinlemesine in, persona, finans, go-to-market ve pitch deck içeren 25–75 sayfalık Builder Report’u dışa aktar.',
  'features.multilingual.title': '21 dil, yerel pazar verisi',
  'features.multilingual.description': 'İsviçreli KOBİ’den São Paulo’daki solo kurucuya — yapay zekâ kendi dilinde, kendi pazarından kaynaklarla cevap verir.',

  // How It Works
  'howItWorks.title': 'Nasıl çalışır',
  'howItWorks.subtitle': 'İş nişiniz hakkında netlik için dört adım.',
  'howItWorks.step1Title': 'Bir plan seçin',
  'howItWorks.step1Desc': 'Starter, Pro veya Builder - incelemenizin derinliğine bağlı olarak.',
  'howItWorks.step2Title': 'Yapay zekaya sorun',
  'howItWorks.step2Desc': 'Niş hakkında sorularınızı sorun. Her istek 30 krediye mal olur.',
  'howItWorks.step3Title': 'Dürüst karar alın',
  'howItWorks.step3Desc': 'Yapay zeka değerlendirir: İyi, Orta veya Kötü. Süslemesiz.',
  'howItWorks.step4Title': 'Bir karar verin',
  'howItWorks.step4Desc': 'Artık ilerlemeye değer olup olmadığını biliyorsunuz.',

  // Pricing
  'pricing.title': 'Fiyatlandırma',
  'pricing.subtitle': 'İncelemenizin derinliğine uygun planı seçin.',
  'pricing.yearlyDiscount': 'Yıllık abonelik:',
  'pricing.yearlyDiscountValue': '-20% indirim',
  'pricing.perMonth': 'aylık',
  'pricing.selectPlan': 'Plan seç',
  'pricing.mostPopular': 'En popüler',
  'pricing.footer': 'Tüm fiyatlar CHF cinsindendir. Krediler yalnızca başarılı yapay zeka yanıtları için düşülür.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'İlk gerçeklik testleri için.',
  'pricing.starter.credits': '2.500 kredi',
  'pricing.starter.feature1': 'Niş fikri oluştur',
  'pricing.starter.feature2': 'Nişi geliştir',
  'pricing.starter.feature3': 'Pazar gerçekliği kontrolü',
  'pricing.starter.feature4': 'Rekabet değerlendirmesi',
  'pricing.starter.feature5': 'Zamanlama değerlendirmesi',
  'pricing.starter.feature6': 'Dürüst karar',
  'pricing.starter.feature7': 'Özel oturumlar',
  'pricing.starter.feature8': 'Geçmiş ve dışa aktarma',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Daha derin inceleme için.',
  'pricing.pro.credits': '5.000 kredi',
  'pricing.pro.feature1': 'Tüm Starter özellikleri',
  'pricing.pro.feature2': 'Yoğun inceleme için daha fazla kredi',
  'pricing.pro.feature3': 'İyileştirme önerileri',
  'pricing.pro.feature4': 'Alternatif nişler',
  'pricing.pro.feature5': 'Detaylı pazar analizi',
  'pricing.pro.feature6': 'Öncelikli destek',
  'pricing.pro.feature7': 'Gelişmiş filtreler',
  'pricing.pro.feature8': 'Oturum favorileri',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Fikir → Geliştirici brifingi.',
  'pricing.builder.credits': 'Sınırsız kredi',
  'pricing.builder.feature1': 'Tüm Pro özellikleri',
  'pricing.builder.feature2': 'Sınırsız yapay zeka istekleri',
  'pricing.builder.feature3': 'Builder modu: Geliştirici brifingi',
  'pricing.builder.feature4': 'Yapılandırılmış proje genel bakışı',
  'pricing.builder.feature5': 'Kullanıcı akışları ve temel işlevler',
  'pricing.builder.feature6': 'Teknik notlar',
  'pricing.builder.feature7': 'Hedef olmayanları tanımla',
  'pricing.builder.feature8': 'Adil kullanım hız sınırı',
  'pricing.builder.limitNote': 'Adil kullanım sınırı',
  'pricing.monthlyReset': 'Aylık sıfırlama',

  // Modal
  'pricing.modal.selected': 'seçildi',
  'pricing.modal.comingSoon': 'Kayıt ve ödeme işleme yakında kullanılabilir olacak.',
  'pricing.modal.patience': 'Size güvenli ve sorunsuz bir deneyim sunmak için çalışıyoruz. Lütfen sabırlı olun.',
  'pricing.modal.understood': 'Anlaşıldı',

  // FAQ
  'faq.title': 'SSS',
  'faq.subtitle': 'Dürüst ve eleştirel yanıtlar.',
  'faq.q1': 'IdeaOracle.ai somut olarak ne yapar?',
  'faq.a1': 'IdeaOracle.ai iş fikirlerini ve nişleri pazar mantığı, gerçek talep, rekabet, farklılaşma ve uygulanabilirlik açısından değerlendirir.\nÖz varsa, stratejik olarak nasıl keskinleştirilebileceğini gösteririz.\nYoksa, bunu söyleriz.',
  'faq.q2': 'Fikir de üretiyor musunuz?',
  'faq.a2': 'Evet.\nAma körü körüne değil.\nPazar mantığına dayalı yaklaşımlar geliştiriyoruz – motivasyona veya trend abartısına değil.',
  'faq.q3': 'İş modellerini optimize ediyor musunuz?',
  'faq.a3': 'Evet – potansiyel varsa.\nHayalleri parlatmıyoruz.\nUygulanabilir konseptleri daha dayanıklı hale getiriyoruz.',
  'faq.q4': 'Sizi diğer yapay zeka araçlarından ne ayırır?',
  'faq.a4': 'Diğer araçlar ilham verir.\nBiz değerlendirme veririz.\nOdak noktası gerçekçilik, heyecan değil.',
  'faq.q5': 'Bu bir başarı garantisi mi?',
  'faq.a5': 'Hayır.\nKötü kararları azaltırız – riski ortadan kaldırmayız.',
  'faq.q6': 'IdeaOracle.ai kimin için uygun?',
  'faq.a6': 'Başlamadan önce kurucular\nGenişlemeden önce girişimciler\nZaman yatırımından önce yan proje yapanlar\nDeğerlendirmeden önce yatırımcılar\n\nKısaca: Sermayeden önce netlik isteyen insanlar için.',
  'faq.q7': 'Ya sadece onay arıyorsam?',
  'faq.a7': 'O zaman IdeaOracle.ai doğru araç değil.',
  'faq.q8': 'Analiz ne kadar dürüst?',
  'faq.a8': 'Veriler ve pazar mekaniğinin izin verdiği kadar dürüst.\nÖfori yok. Merhamet yok.',
  'faq.q9': 'Pazar araştırmasının yerini alıyor musunuz?',
  'faq.a9': 'Hayır.\nBiz stratejik bir ön değerlendirmeyiz – tam bir pazar araştırması değil.',
  'faq.q10': 'Neden bu kadar taviz vermez?',
  'faq.a10': 'Çünkü başarısızlık pahalıdır.\nDürüstlük değil.',

  // Footer
  'footer.description': 'Bu platform kendinizi iyi hissetmenize değil - doğru karar vermenize yardımcı olur.',
  'footer.product': 'Ürün',
  'footer.aiAssistant': 'Yapay zeka asistanı',
  'footer.howItWorks': 'Nasıl çalışır',
  'footer.pricing': 'Fiyatlandırma',
  'footer.faq': 'SSS',
  'footer.legal': 'Yasal',
  'footer.privacy': 'Gizlilik',
  'footer.terms': 'Şartlar',
  'footer.imprint': 'Künye',
  'footer.support': 'Destek',
  'footer.contact': 'İletişim',
  'footer.documentation': 'Dokümantasyon',
  'footer.copyright': '© 2025 IdeaOracle.ai. Tüm hakları saklıdır.',

  // AI Assistant
  'aiAssistant.title': 'Yapay zeka niş asistanı',
  'aiAssistant.subtitle': 'Nişler hakkında sorular',
  'aiAssistant.welcomeMessage': 'Merhaba! Fikrinizi açıklayın veya bana bir niş hakkında sorun. Size net ve dürüst bir değerlendirme vereceğim.',
  'aiAssistant.demoResponse': 'Bu bir demo. Gerçek yapay zeka değerlendirmeleri almak için lütfen kaydolun ve bir plan seçin.',
  'aiAssistant.placeholder': 'Fikrinizi açıklayın...',

  // Header & Sidebar
  'dashboard.header.title': 'Gösterge paneli',
  'dashboard.sidebar.overview': 'Genel bakış',
  'dashboard.sidebar.newAnalysis': 'Yapay zeka asistanı',
  'dashboard.sidebar.history': 'Geçmiş',
  'dashboard.sidebar.credits': 'Krediler',
  'dashboard.sidebar.settings': 'Ayarlar',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Tekrar hoş geldiniz, {{name}}',
  'dashboard.overview.subtitle': 'İşte aktivitenizin hızlı bir özeti',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Kalan krediler',
  'dashboard.stats.totalAnalyses': 'Toplam analizler',
  'dashboard.stats.goodRatings': 'Olumlu değerlendirmeler',
  'dashboard.stats.nextReset': 'Sonraki sıfırlama',
  'dashboard.stats.days': 'gün',

  // Quick Actions
  'dashboard.quickActions.title': 'Hızlı işlemler',
  'dashboard.quickActions.checkNewIdea': 'Bir fikri kontrol et',
  'dashboard.quickActions.checkNewIdeaDesc': 'Mevcut bir iş fikrini analiz et',
  'dashboard.quickActions.generateIdea': 'Bir fikir oluştur',
  'dashboard.quickActions.generateIdeaDesc': 'Yeni karlı bir niş bul',
  'dashboard.quickActions.builderBriefing': 'Builder brifingi',
  'dashboard.quickActions.builderBriefingDesc': 'Bir fikri geliştirici için hazır bir briefinge dönüştür',
  'dashboard.quickActions.premiumOnly': 'Sadece Builder',

  // Chat Header
  'chat.title': 'Yapay zeka niş asistanı',
  'chat.subtitle': 'Nişler hakkında sorular sorun. Eleştirel ve dürüst değerlendiririm.',
  'chat.creditsLabel': 'Krediler',

  // Chat Welcome
  'chat.welcomeTitle': 'Yapay zeka niş asistanına hoş geldiniz',
  'chat.welcomeDesc': 'Fikrinizi açıklayın veya bir niş hakkında sorun. Dürüstçe değerlendireceğim: İyi, Orta veya Kötü.',
  'chat.aiWelcome': 'Merhaba! Fikrinizi açıklayın veya bana bir niş hakkında sorun. Size net ve dürüst bir değerlendirme vereceğim.',

  // Chat Suggestions
  'chat.suggestion1': 'Bana karlı bir niş bul.',
  'chat.suggestion2': 'Bir fikrim var - dürüstçe değerlendir.',
  'chat.suggestion3': 'Şu anda hangi nişlerin potansiyeli var?',
  'chat.suggestion4': 'Bu nişi geliştir ve daha spesifik hale getir.',

  // Chat Actions
  'chat.newConversation': 'Yeni sohbet',
  'chat.today': 'Bugün',
  'chat.yesterday': 'Dün',
  'chat.thisWeek': 'Bu hafta',
  'chat.thisMonth': 'Bu ay',
  'chat.older': 'Daha eski',
  'chat.messages': 'mesajlar',
  'chat.renameConversation': 'Yeniden adlandır',
  'chat.deleteConversation': 'Sil',
  'chat.cancel': 'İptal',
  'chat.rename': 'Yeniden adlandır',
  'chat.delete': 'Sil',
  'chat.favorite': 'Favorilere ekle',
  'chat.unfavorite': 'Favorilerden çıkar',
  'chat.searchSessions': 'Sohbetleri ara...',
  'chat.noResults': 'Sonuç bulunamadı',
  'chat.noSessions': 'Henüz sohbet yok',
  'chat.enterNewName': 'Yeni ad girin...',
  'chat.deleteConfirmMessage': 'Bu sohbeti silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Sorunuzu yazın… (30 krediye mal olur)',
  'chat.send': 'Gönder',
  'chat.voice': 'Konuş',
  'chat.listeningPlaceholder': 'Dinliyorum... Şimdi konuşun.',
  'chat.stopListening': 'Kaydı durdur',
  'chat.recording': 'Kaydediliyor...',
  'chat.speechNotSupported': 'Konuşma tanıma tarayıcınız tarafından desteklenmiyor.',
  'chat.microphonePermissionDenied': 'Mikrofon erişimi reddedildi. Lütfen tarayıcı ayarlarınızdan erişime izin verin.',
  'chat.errorNotEnoughCredits': 'Yeterli kredi yok. Lütfen planınızı yükseltin veya bir sonraki sıfırlamayı bekleyin.',
  'chat.errorAiFailed': 'Yapay zeka yanıtı başarısız oldu. Kredi düşülmedi.',
  'chat.errorRateLimit': 'Çok fazla istek. Lütfen bir an bekleyin.',

  // Ratings
  'rating.good': 'İyi',
  'rating.medium': 'Orta',
  'rating.bad': 'Kötü',

  // Auth Page
  'auth.branding.headline1': 'Her fikir iyi değildir.',
  'auth.branding.headline2': 'Hangisinin iyi olduğunu dürüstçe söylüyoruz.',
  'auth.branding.subtitle': 'İş nişleri için bir karar yapay zekası. Net. Eleştirel. Süslemesiz.',
  'auth.benefits.privacy.title': '100% Özel',
  'auth.benefits.privacy.desc': 'Fikirleriniz tamamen özel ve güvende kalır.',
  'auth.benefits.honest.title': 'Dürüst Yapay Zeka',
  'auth.benefits.honest.desc': 'Süslemesiz – sadece net, eleştirel geri bildirim.',
  'auth.benefits.fast.title': 'Hızlı Sonuçlar',
  'auth.benefits.fast.desc': 'Nişiniz hakkında dakikalar içinde netlik kazanın.',
  'auth.trust.users': 'Aktif Kullanıcılar',
  'auth.trust.ideas': 'Analiz Edilen Fikirler',
  'auth.trust.rating': 'Değerlendirme',
  'auth.login.title': 'Giriş Yap',
  'auth.login.headline': 'Tekrar hoş geldiniz',
  'auth.login.subtitle': 'Yolculuğunuza devam etmek için giriş yapın.',
  'auth.login.forgotPassword': 'Şifrenizi mi unuttunuz?',
  'auth.login.submit': 'Giriş Yap',
  'auth.login.noAccount': 'Hesabınız yok mu?',
  'auth.login.signUp': 'Kaydol',
  'auth.register.title': 'Kaydol',
  'auth.register.headline': 'Hesabınızı oluşturun',
  'auth.register.subtitle': 'Bugün iş fikirlerinizi analiz etmeye başlayın.',
  'auth.register.submit': 'Hesap Oluştur',
  'auth.register.hasAccount': 'Zaten hesabınız var mı?',
  'auth.register.signIn': 'Giriş yap',
  'auth.fields.name': 'Tam Ad',
  'auth.fields.email': 'E-posta Adresi',
  'auth.fields.password': 'Şifre',
  'auth.fields.confirmPassword': 'Şifreyi Onayla',
  'auth.fields.selectPlan': 'Planınızı seçin',
  'auth.placeholders.name': 'Adınızı girin',
  'auth.placeholders.email': 'E-postanızı girin',
  'auth.placeholders.password': 'Şifrenizi girin',
  'auth.placeholders.confirmPassword': 'Şifrenizi onaylayın',
  'auth.terms.accept': 'Kabul ediyorum',
  'auth.terms.terms': 'Şartlar ve Koşullar',
  'auth.privacy.accept': 'Kabul ediyorum',
  'auth.privacy.policy': 'Gizlilik Politikası',
  'auth.errors.nameRequired': 'Ad gereklidir',
  'auth.errors.emailRequired': 'E-posta gereklidir',
  'auth.errors.emailInvalid': 'Lütfen geçerli bir e-posta girin',
  'auth.errors.passwordRequired': 'Şifre gereklidir',
  'auth.errors.passwordLength': 'Şifre en az 8 karakter olmalıdır',
  'auth.errors.passwordMismatch': 'Şifreler eşleşmiyor',
  'auth.loading': 'Lütfen bekleyin...',
  'auth.or': 'veya şununla devam et',
  'auth.social.google': 'Google ile devam et',
  'auth.social.apple': 'Apple ile devam et',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3 gün ücretsiz erişim',
  'pricing.trial.credits': '250 kredi',
  'pricing.trial.free': 'Ücretsiz',
  'pricing.trial.duration': '3 gün ücretsiz',
  'pricing.trial.cta': 'Ücretsiz denemeyi başlat',
  'pricing.trial.feature1': 'AI\'ı keşfetmek için 250 kredi',
  'pricing.trial.feature2': '3 gün tam erişim',
  'pricing.trial.feature3': 'Kredi kartı gerekmez',
  'pricing.trial.feature4': 'İstediğiniz zaman iptal edin',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10.000 kredi + 25 sayfalık Builder raporu',
  'pricing.gold.credits': '10.000 kredi',
  'pricing.gold.feature1': '10.000 kredi',
  'pricing.gold.feature2': '25 sayfalık Builder raporu',
  'pricing.gold.feature3': 'Tüm Starter ve Pro özellikleri',
  'pricing.gold.feature4': 'Pazar analizi ve özet',
  'pricing.gold.feature5': 'Fırsatlar, riskler, öneriler',
  'pricing.gold.feature6': 'PDF indir',
  'pricing.gold.feature7': 'Destek',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15.000 kredi + 100 sayfalık Builder raporu',
  'pricing.platinum.credits': '15.000 kredi',
  'pricing.platinum.feature1': '15.000 kredi',
  'pricing.platinum.feature2': '100 sayfalık Builder raporu',
  'pricing.platinum.feature3': 'Tüm Gold özellikleri',
  'pricing.platinum.feature4': 'Builder modu: geliştirici brifingleri',
  'pricing.platinum.feature5': 'Yapılandırılmış özet',
  'pricing.platinum.feature6': 'Gelişmiş pazar analizi',
  'pricing.platinum.feature7': 'Destek',

  // Pricing UI
  'pricing.monthly': 'Aylık',
  'pricing.yearly': 'Yıllık',
  'pricing.savings': 'tasarruf',
  'pricing.billedYearly': 'Yıllık faturalandırılır',

  // Hero trial CTA
  'hero.trialTitle': 'Ücretsiz denemenizi başlatın',
  'hero.creditsLabel': 'Kredi',
  'hero.trialTagline': 'AI asistanımızı 3 gün ücretsiz deneyin',
  'hero.trialCta': 'Kayıt olun ve 250 kredi alın',
  'hero.trialNoCard': 'Kredi kartı gerekmez. Taahhüt yok.',

  // Admin
  'admin.dashboard.tabs.plans': 'Planlar',

  // Credit top-up
  'dashboard.credits.topup.button': 'Kredi yükle',
  'dashboard.credits.topup.buttonTitle': 'Plan değiştirmeden daha fazla kredi satın alın',
  'dashboard.credits.topup.title': 'Kredi yükle',
  'dashboard.credits.topup.subtitle': 'Kredi başına CHF 0,15 — plan değişikliği gerekmez',
  'dashboard.credits.topup.quickAmounts': 'Hızlı seçim',
  'dashboard.credits.topup.custom': 'Özel',
  'dashboard.credits.topup.totalLabel': 'Toplam',
  'dashboard.credits.topup.creditsLabel': 'Kredi',
  'dashboard.credits.topup.confirm': 'Şimdi satın al',
  'footer.disclaimer': 'Yasal Uyarı',
  'legal.backToHome': 'Ana sayfaya dön',
  'legal.lastUpdated': 'Son güncelleme',
  'legal.allRightsReserved': 'Tüm hakları saklıdır.',
  'legal.authoritativeNotice': 'Dilinizde yerelleştirilmiş bir sürüm henüz mevcut değil. Aşağıda hukuken bağlayıcı İngilizce metin gösterilmektedir.',
  'legal.translationNotice': 'Bu, kolaylık sağlamak için yapılmış bir çeviridir. Hukuken bağlayıcı olan İngilizce orijinaldir.',
};

export default common;
